import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/dist/query/react'

export const authApi = createApi({
    reducerPath: 'authApi',
    baseQuery: fetchBaseQuery({
        baseUrl: process.env.REACT_APP_API_URL,
        prepareHeaders: (headers, { getState }: {getState: () => any}) => {
        const token = getState().auth.token || localStorage.getItem('token');
        
        if (token) {
            headers.set("Authorization", `Bearer ${token}`)
        }

        return headers
    }
    }),
    endpoints: (builder) => ({
        sendOtp: builder.mutation({
            query: (body) => ({
                url: '/admin/auth/otp/send',
                method: 'POST',
                body: body
            })
        }),
        checkOtp: builder.mutation({
            query: (body) => ({
                url: '/admin/auth/otp/check',
                method: 'POST',
                body: body
            })
        }),
        checkToken: builder.mutation({
            query: () => ({
                url: `/admin/auth/check`,
                method: 'POST',
            })
        }),
    })
})
